import { useSelector } from "react-redux";
import PlaceholderImage from "../../products/PlaceholderImage";
import deployFastIcon from "../../../assets/smartbuilding/featuresIcon/deployFast.png";
import energyGraphsIcon from "../../../assets/smartbuilding/featuresIcon/energyGraphs.png";
import locationIcon from "../../../assets/smartbuilding/featuresIcon/location.png";
import manualOverrideIcon from "../../../assets/smartbuilding/featuresIcon/manualOverride.png";
import noInternetIcon from "../../../assets/smartbuilding/featuresIcon/noInternet.png";
import realTimeInfoIcon from "../../../assets/smartbuilding/featuresIcon/realTimeInfo.png";
import saveEnergyIcon from "../../../assets/smartbuilding/featuresIcon/saveEnergy.png";
import settingsIcon from "../../../assets/smartbuilding/featuresIcon/settings.png";
import featuresBackground from "../../../assets/smartbuilding/featuresIcon/featuresBackground.png";
import hypervisionLogo from "../../../assets/smartbuilding/featuresIcon/hypervision.png";
import textContentSmarthomeContactUsSection from "../../smarthome/ui/textContent-smarthome-contactUsSection";

export default function FeaturesSection(props) {
  const { textContent, language } = { ...props };

  const isMobile = useSelector((state) => state.screen.isMobile);

  const features = [
    {
      id: "energy",
      icon: energyGraphsIcon,
    },
    {
      id: "control",
      icon: settingsIcon,
    },

    {
      id: "optimisation",
      icon: saveEnergyIcon,
    },
    {
      id: "override",
      icon: manualOverrideIcon,
    },
    {
      id: "remoteDiagnostic",
      icon: locationIcon,
    },
    {
      id: "realTimeinfo",
      icon: realTimeInfoIcon,
    },
    {
      id: "fastDeployment",
      icon: deployFastIcon,
    },

    {
      id: "noInternet",
      icon: noInternetIcon,
    },
  ];

  return (
    <section className="container">
      <section className="features-section">
        <div className="features-grid">
          {features.map((f) => (
            <article key={f.id} className="features-card">
              <div className="features-icon" aria-hidden="true">
                <img src={f.icon} aria-hidden="true" />
              </div>
              <p
                className="features-text"
                dangerouslySetInnerHTML={{
                  __html:
                    textContent?.featuresSection?.features[f.id]?.description[
                      language
                    ],
                }}
              />
            </article>
          ))}
        </div>
      </section>
      <div className="container-empty-medium" />
      {isMobile ? <div className="container-empty-small" /> : null}
      <div className="features-hypervision">
        <img
          src={featuresBackground}
          aria-hidden="true"
          className="features-hypervision-bg"
        />
        <div className="features-hypervision-overlay">
          <div className="features-hypervision-logo">
            <img src={hypervisionLogo} aria-hidden="true" />
          </div>
          <div className="features-hypervision-cards">
            <div className="feature-hypervision-card">
              <h2>
                {
                  textContent?.featuresSection?.features?.hypervision?.title[
                    language
                  ]
                }
              </h2>
              <p>
                {
                  textContent?.featuresSection?.features?.hypervision
                    ?.description[language]
                }
              </p>
            </div>

            <div className="feature-hypervision-card two">
              <h2>
                {
                  textContent?.featuresSection?.features?.simpleToUse?.title[
                    language
                  ]
                }
              </h2>
              <p>
                {
                  textContent?.featuresSection?.features?.simpleToUse
                    ?.description[language]
                }
              </p>
            </div>

            <div className="feature-hypervision-card three">
              <h2>
                {
                  textContent?.featuresSection?.features?.thermalFlexibility
                    ?.title[language]
                }
              </h2>
              <p>
                {
                  textContent?.featuresSection?.features?.thermalFlexibility
                    ?.description[language]
                }
              </p>
            </div>

            <div className="feature-hypervision-card four">
              <h2>
                {
                  textContent?.featuresSection?.features?.securedAccess?.title[
                    language
                  ]
                }
              </h2>
              <p>
                {
                  textContent?.featuresSection?.features?.securedAccess
                    ?.description[language]
                }
              </p>
            </div>
          </div>
          <a
            href="https://www.polynhome.io/nous-contacter/"
            className="ask-for-demo-button"
          >
            {textContentSmarthomeContactUsSection?.askForDemo?.title[language]}
          </a>
        </div>
      </div>
    </section>
  );
}
